import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import styled from "styled-components";
import { RDVButton, Inner } from "../../components/commonWidgets";
import HighlightTitle from "../../components/HighlightTitle";
import theme from "../../theme";
import AnimateOnScroll from "../../components/AnimateOnScroll";

const Section = styled.section`
  /*  background-color: #ffffff;*/
  width: 100%;
  padding: 2rem 0;
`;

const Container = styled(Inner)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  max-width: 800px;
  text-align: center;
  height: 100%;
  min-height: 360px;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: var(--my-color3);
  margin-top: 1rem;
  max-width: 600px;
`;

const CarouselWrapper = styled.div`
  width: 100%;
  margin-top: 2rem;

  .swiper {
    padding-bottom: 2.5rem; /* space for pagination bullets */
  }

  .swiper-pagination-bullet {
    background: var(--my-color3);
    opacity: 0.4;
  }

  .swiper-pagination-bullet-active {
    background: var(--my-color5);
    opacity: 1;
  }
`;

const TestimonialCard = styled.div`
  background-color: #ffffff;
  border: 2px solid var(--my-color3);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: left;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

const TestimonialHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
  height: 3rem;
`;

const Avatar = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  background-color: var(--my-color3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
`;

const ClientInfo = styled.div`
  flex: 1;
`;

const ClientName = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  color: var(--my-color3);
  font-weight: bold;
`;

const ClientSector = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: var(--my-color3);
  opacity: 0.8;
`;

const Metric = styled.div`
  font-size: 1.5rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--my-color5);
  margin: 1rem 0;
  text-align: center;
`;

const TestimonialText = styled.p`
  font-size: 0.9rem;
  line-height: 1.4rem;
  color: var(--my-color3);
  margin: 0;
  font-style: italic;
  flex: 1;
`;

const ButtonWrapper = styled.div`
  margin-top: 2rem;
`;

const TestimonialsSection = () => {
  const testimonials = [
    {
      avatar: "M",
      name: "Maxime",
      sector: "Freelance Google Ads",
      metric: "+35% de conversion",
      text: "Landing page + vidéo de présentation = transformation complète de mon business. Avant : 2 clients/mois. Après : 8 clients/mois. Le site one-page + stratégie LinkedIn ont fait la différence.",
    },
    {
      avatar: "V",
      name: "Vincent",
      sector: "PME BTP",
      metric: "-40% de temps admin",
      text: "CRM sur-mesure + application mobile pour les conducteurs. Nos équipes gagnent 2h/jour, et les clients sont ravis du suivi en temps réel. Dashboard qui change tout.",
    },
    {
      avatar: "T",
      name: "Thomas",
      sector: "Start-up SaaS",
      metric: "MVP en 3 semaines",
      text: "Au lieu de 3 mois de développement, on a livré un MVP fonctionnel en 3 semaines. Interface qui convertit 23% des visiteurs + API automatisée pour les intégrations.",
    },
    {
      avatar: "M",
      name: "Marie",
      sector: "Boutique en ligne",
      metric: "+45% de ventes",
      text: "Application mobile e-commerce + PWA qui fonctionne hors ligne. Synchronisation panier web/mobile parfaite. Nos clients achètent maintenant partout, tout le temps.",
    },
  ];

  return (
    <Section>
      <Container>
        <HighlightTitle
          text="Ils nous font déjà confiance"
          highlightWord="confiance"
          bg="var(--my-color3)"
          rotateText={false}
          mainTextColor="var(--my-color3)"
          textColor="white"
        />
        <Subtitle>
          Quelques exemples récents parmi les entreprises que nous accompagnons.
        </Subtitle>
        <CarouselWrapper>
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 6000, disableOnInteraction: false }}
            spaceBetween={20}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index} style={{ height: "auto" }}>
                <AnimateOnScroll type="fade" style={{ height: "100%" }}>
                  <TestimonialCard>
                    <TestimonialHeader>
                      <Avatar>{testimonial.avatar}</Avatar>
                      <ClientInfo>
                        <ClientName>{testimonial.name}</ClientName>
                        <ClientSector>{testimonial.sector}</ClientSector>
                      </ClientInfo>
                    </TestimonialHeader>
                    <Metric>{testimonial.metric}</Metric>
                    <TestimonialText>"{testimonial.text}"</TestimonialText>
                  </TestimonialCard>
                </AnimateOnScroll>
              </SwiperSlide>
            ))}
          </Swiper>
        </CarouselWrapper>
        {false && (
          <ButtonWrapper>
            <RDVButton label="Voir plus de témoignages" />
          </ButtonWrapper>
        )}
      </Container>
    </Section>
  );
};

export default TestimonialsSection;
